export const checkVideoResolution = (file) => {
  return new Promise((resolve) => {
    if (!file || !file.type.startsWith('video/')) {
      resolve({ is4K: false, width: 0, height: 0 });
      return;
    }
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      const is4K = video.videoWidth >= 3840 || video.videoHeight >= 2160;
      resolve({ is4K, width: video.videoWidth, height: video.videoHeight });
    };
    video.onerror = () => {
      resolve({ is4K: false, width: 0, height: 0 });
    };
    video.src = URL.createObjectURL(file);
  });
};
